import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { SpecialAssistanceRequestState } from '@common/helpers/constants/my-booking/passenger-information-input-modal.state';
import { SpecialAssistanceRequestWheelchairsData } from '@common/interfaces/mybooking/modals/passenger-information-input/special-assistance-request-modal.interface';
import { ValidationErrorInfo } from '@lib/interfaces/validate';

/**
 * サポート情報入力モーダル
 */
@Component({
  selector: 'asw-special-assistance-request-modal-wheelchairs',
  templateUrl: './special-assistance-request-modal-wheelchairs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialAssistanceRequestModalWheelchairsComponent implements OnDestroy {
  @Input()
  get data() {
    return this._data;
  }
  set data(value: SpecialAssistanceRequestWheelchairsData | undefined) {
    this._data = value;
    this.refresh();
  }
  private _data?: SpecialAssistanceRequestWheelchairsData;

  @Output()
  dataChange: EventEmitter<SpecialAssistanceRequestWheelchairsData> =
    new EventEmitter<SpecialAssistanceRequestWheelchairsData>();

  public id = this.constructor.name;
  public selectError: ValidationErrorInfo | null = null;
  public willBeCheckedIn?: boolean;
  public wheelchairsSelectList = [
    { value: true, label: 'label.willBeCheckedIn' },
    { value: false, label: 'label.willNotBeCheckedIn' },
  ];

  constructor(private _change: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.apply();
  }

  refresh() {
    this.willBeCheckedIn = this.data?.willBeCheckedIn;
    this._change.markForCheck();
  }

  apply() {
    if (!this.data) {
      return;
    }

    this.data.willBeCheckedIn = this.willBeCheckedIn;

    this.dataChange.emit(this.data);
  }

  isError() {
    if (this.willBeCheckedIn === undefined) {
      this.selectError = SpecialAssistanceRequestState.Wheelchairs;
      return true;
    }
    return false;
  }

  // (38) 車いす持ち込み有無の値更新処理
  onChangeWillBeCheckedIn(value: boolean) {
    this.willBeCheckedIn = value;
    this.selectError = null;

    this.apply();
  }
}
